module.exports = __webpack_public_path__ + "img/p-single-g2.59681c73.jpg";